// extracted by mini-css-extract-plugin
export default {"whatsappLive":"Home_whatsappLive__9zeDE","whatsappBoxImg":"Home_whatsappBoxImg__vmzwF","whatsappBox":"Home_whatsappBox__Pzafh"};